import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="relative h-[90vh] min-h-[600px] flex items-center bg-stone-50 overflow-hidden pt-20">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?q=80&w=2000&auto=format&fit=crop" 
          alt="Person hiking with TerraSip bottle" 
          className="w-full h-full object-cover object-center opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/70 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-xl text-white"
        >
          <span className="uppercase tracking-widest text-sm font-semibold mb-4 block text-teal-300">
            Engineered for Life
          </span>
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 leading-tight">
            Hydration,<br/>Reimagined.
          </h1>
          <p className="text-lg md:text-xl mb-8 text-stone-200 font-light max-w-md">
            Premium drinkware designed for your daily commute and built for the circular economy. Never buy single-use again.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#shop" className="bg-white text-stone-900 px-8 py-4 rounded-full font-medium text-center hover:bg-stone-100 transition-colors">
              Shop Collection
            </a>
            <a href="#loop" className="bg-transparent border border-white text-white px-8 py-4 rounded-full font-medium text-center hover:bg-white/10 transition-colors">
              Explore The Loop
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}